"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleDrawerItem_1 = require("./RawExampleDrawerItem");
var ContentExampleDrawerItem_1 = require("./ContentExampleDrawerItem");
var PropertiesDrawerItem_1 = require("./PropertiesDrawerItem");
exports.ComponentDrawerItemPage = function () { return (React.createElement(common_1.Page, { headerText: "Drawer Item" },
    React.createElement(common_1.Paragraph, null, "Drawer Item is an item that you can put inside a Drawer. So, only make sense show all these examples with a Drawer as a wrapper."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleDrawerItem_1.RawExampleDrawerItem, null),
    React.createElement(ContentExampleDrawerItem_1.ContentExampleDrawerItem, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesDrawerItem_1.PropertiesDrawerItem, null))); };
exports.ComponentDrawerItemPage.displayName = 'ComponentDrawerItemPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerItemPage/ComponentDrawerItemPage.tsx
// module id = 654
// module chunks = 0